module.exports = __webpack_public_path__ + "static/media/Corded_ware_germany_text_03.2d66f68d.jpg";